import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setGetCountOnline = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_COUNT_STATUS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetCountOnlineAction(data.data))
            }

        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetCountOnline as SetGetCountOnline
}